import React from 'react';
import { Facebook, Twitter, Instagram, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-marine text-white">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-6">
              Marine Fuel Boost
            </h3>
            <p className="mb-6 text-white/80">
              Premium fuel additives for marine engines. Protect your investment with the most advanced fuel treatment technology.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-white/80 hover:text-marine-lightest transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-white/80 hover:text-marine-lightest transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-white/80 hover:text-marine-lightest transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>
          
          {/* Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })} className="text-white/80 hover:text-marine-lightest transition-colors">Products</Link></li>
              <li><Link to="/" onClick={() => document.getElementById('benefits')?.scrollIntoView({ behavior: 'smooth' })} className="text-white/80 hover:text-marine-lightest transition-colors">Benefits</Link></li>
              <li><Link to="/" onClick={() => document.getElementById('testimonials')?.scrollIntoView({ behavior: 'smooth' })} className="text-white/80 hover:text-marine-lightest transition-colors">Testimonials</Link></li>
              <li><Link to="/faq" className="text-white/80 hover:text-marine-lightest transition-colors">FAQ</Link></li>
              <li><Link to="/privacy-policy" className="text-white/80 hover:text-marine-lightest transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-white/80 hover:text-marine-lightest transition-colors">Terms of Service</Link></li>
              <li><Link to="/shipping-policy" className="text-white/80 hover:text-marine-lightest transition-colors">Shipping Policy</Link></li>
              <li><Link to="/return-policy" className="text-white/80 hover:text-marine-lightest transition-colors">Return Policy</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-center">
                <Mail className="mr-2 text-marine-lightest" size={18} />
                <a href="mailto:support@marinefuelboost.com" className="text-white/80 hover:text-marine-lightest transition-colors">
                  support@marinefuelboost.com
                </a>
              </div>
              <div className="flex items-center">
                <Phone className="mr-2 text-marine-lightest" size={18} />
                <a href="tel:+19704382963" className="text-white/80 hover:text-marine-lightest transition-colors">
                  (970) 438-2963
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-marine-light/20 text-center text-white/60 text-sm">
          <p>&copy; {currentYear} Marine Fuel Boost. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
